<template>
  <div class="login_footer" v-if="!this.isPopFrame">
    <p>{{ $t('newDategetfullyearShuYiKeJiBanQuanSuoYou', [new Date().getFullYear()]) }} </p>
    <p>{{ $t('beiAnHaoShuIcpBei_14015776Hao_2') }}蜀ICP备14015776号-2</p>
  </div>
</template>

<script>

import { mapState } from 'vuex'

export default {
  name: 'loginFooter',
  components: {},
  data: () => ({}),
  methods: {
  },
  created () {
  },
  computed: {
    ...mapState({
      isPopFrame: state => state.publicModules.isPopFrame
    })
  }
}
</script>

<style scoped lang="scss">

</style>
